import { render, staticRenderFns } from "./DailyScoreEditor.vue?vue&type=template&id=37b996df&"
import script from "./DailyScoreEditor.vue?vue&type=script&lang=js&"
export * from "./DailyScoreEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports